import React from "react";

const MenuIcon = () => {
  const style = {
    fontSize: "0.875rem",
    cursor: "pointer",
    color: "#091caa",
  };
  return (
    <svg
      data-bs-toggle="dropdown"
      aria-expanded="false"
      style={style}
      width="4"
      height="17"
      viewBox="0 0 4 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.63989 10C2.46832 10 3.13989 9.32843 3.13989 8.5C3.13989 7.67157 2.46832 7 1.63989 7C0.811465 7 0.139893 7.67157 0.139893 8.5C0.139893 9.32843 0.811465 10 1.63989 10Z"
        fill="black"
      />
      <path
        d="M1.63989 3C2.46832 3 3.13989 2.32843 3.13989 1.5C3.13989 0.671573 2.46832 0 1.63989 0C0.811465 0 0.139893 0.671573 0.139893 1.5C0.139893 2.32843 0.811465 3 1.63989 3Z"
        fill="black"
      />
      <path
        d="M1.63989 17C2.46832 17 3.13989 16.3284 3.13989 15.5C3.13989 14.6716 2.46832 14 1.63989 14C0.811465 14 0.139893 14.6716 0.139893 15.5C0.139893 16.3284 0.811465 17 1.63989 17Z"
        fill="black"
      />
    </svg>
  );
};

export default MenuIcon;
